import { request } from "../../request";

export const getNotifications = (id, type, page, rowPerPage) => {
  return request.get(`notification/read/${id}/${type}/${page}/${rowPerPage}`);
};
export const getDataCount = (id) => {
  return request.get(`survey/count-total-data/${id}`);
};
